import * as React from "react";
import { Card, Form } from "react-bootstrap";
import style from "./style.module.css";
import { observer } from "mobx-react-lite";
import { getStore } from "../../store";

export const JsonExchanger = observer(() => {
  const store = getStore().list;

  const handleJsonImport = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    e.stopPropagation();
    store.importJson(e.currentTarget.value);
  };

  return (
    <div className={style.root}>
      <Card className="mb-2">
        <Card.Header>
          JSON形式で、イベント定義を一括インポート/エクスポートできます。
        </Card.Header>
        <Card.Body>
          <ul>
            <li>
              インポートする場合は以下のテキストエリアにペーストしてください。
            </li>
          </ul>
        </Card.Body>
      </Card>
      <Form.Group>
        <Form.Control
          as="textarea"
          rows={20}
          value={store.json}
          onChange={(e) => handleJsonImport(e)}
          isValid={!store.jsonError}
        />
        <Form.Control.Feedback>{store.jsonError}</Form.Control.Feedback>
      </Form.Group>
    </div>
  );
});
